import { z } from 'zod';

export const MoveOutStatusName = z.enum([
  '搬入先未確認',
  '搬入先が不一致',
  '搬入先確認済',
  '搬出手配不要',
  '搬出可能',
  '配車完了待ち',
  '搬出オーダー送信待ち',
  '搬出手配済',
]);

export type MoveOutStatusName = z.infer<typeof MoveOutStatusName>;

export const MoveOutStatus = z.object({
  name: MoveOutStatusName,
  time: z.string(),
});

export type MoveOutStatus = z.infer<typeof MoveOutStatus>;
